export default __webpack_public_path__ + "static/media/02.c233b4c8.jpg";